<h2 mat-dialog-title>Restablecer contraseña</h2>
<form #myForm="ngForm" (ngSubmit)="enviar()">
  <mat-dialog-content>
    <mat-form-field style="width: 100%;">
        <mat-label>Correo electrónico</mat-label>
        <input  #myemail="ngModel" matInput placeholder="" type="email" value="" name="emailRestablecer" [(ngModel)]="emailRestablecer" required>
        <div *ngIf="myemail.errors?.required && myemail.touched" class="error">
          El correo es obligatorio
        </div>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button mat-dialog-close type="button">Cerrar</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="!myForm.valid" >Enviar link</button>
    <div class="error" *ngIf="error">
      {{ error }}
    </div>
    <div *ngIf="exito" style="margin-top: 20px;">
      Correo enviado con éxito. Ingresar al correo para restablecer la contraseña.
    </div>
  </mat-dialog-actions>

</form>
